import React from 'react';
import { TrendingUpIcon, CheckIcon, AlertTriangleIcon, XIcon } from 'lucide-react';
import type { Division, MetricType, PeriodInfo } from '../../types';
import { aggregateDivisionMetrics, getProgressPercentage, getProgressStatus, calculateProjection } from '../../utils/calculations';
interface MetricSummaryProps {
  divisions: Division[];
  period: PeriodInfo;
  metric: MetricType;
}
export function MetricSummary({
  divisions,
  period,
  metric
}: MetricSummaryProps) {
  let totalCurrent = 0;
  let totalGoal = 0;
  let onTrackCount = 0;
  let atRiskCount = 0;
  let behindCount = 0;
  // Count per-LO statuses
  for (const division of divisions) {
    const divMetrics = aggregateDivisionMetrics(division, metric);
    totalCurrent += divMetrics.current;
    totalGoal += divMetrics.goal;
    for (const team of division.teams) {
      for (const lo of team.loanOfficers) {
        const current = metric === 'softPull' ? lo.softPullCount : lo.submittedCount;
        const goal = metric === 'softPull' ? lo.softPullGoal : lo.submittedGoal;
        const projected = calculateProjection(current, period.daysElapsed, period.totalDays);
        const projPct = getProgressPercentage(projected, goal);
        const status = getProgressStatus(projPct);
        if (status === 'on-track') onTrackCount++;else if (status === 'at-risk') atRiskCount++;else behindCount++;
      }
    }
  }
  const overallPct = getProgressPercentage(totalCurrent, totalGoal);
  const cards = [{
    label: 'Total Progress',
    value: `${totalCurrent} / ${totalGoal}`,
    sub: `${overallPct}% complete`,
    icon: <TrendingUpIcon className="w-5 h-5 text-blue-600" data-id="element-54" />,
    bg: 'bg-blue-50',
    border: 'border-blue-200'
  }, {
    label: 'On Track',
    value: `${onTrackCount}`,
    sub: 'Loan Officers',
    icon: <CheckIcon className="w-5 h-5 text-emerald-600" data-id="element-55" />,
    bg: 'bg-emerald-50',
    border: 'border-emerald-200'
  }, {
    label: 'At Risk',
    value: `${atRiskCount}`,
    sub: 'Loan Officers',
    icon: <AlertTriangleIcon className="w-5 h-5 text-amber-600" data-id="element-56" />,
    bg: 'bg-amber-50',
    border: 'border-amber-200'
  }, {
    label: 'Behind',
    value: `${behindCount}`,
    sub: 'Loan Officers',
    icon: <XIcon className="w-5 h-5 text-red-600" data-id="element-57" />,
    bg: 'bg-red-50',
    border: 'border-red-200'
  }];
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-58">
      {cards.map(card => <div key={card.label} className={`rounded-lg border ${card.border} ${card.bg} p-4`} data-id="element-59">
          <div className="flex items-center justify-between mb-2" data-id="element-60">
            <span className="text-sm font-medium text-gray-600" data-id="element-61">
              {card.label}
            </span>
            <div className="w-8 h-8 rounded-lg bg-white flex items-center justify-center shadow-sm" data-id="element-62">
              {card.icon}
            </div>
          </div>
          <p className="text-2xl font-bold text-gray-900" data-id="element-63">{card.value}</p>
          <p className="text-xs text-gray-500 mt-0.5" data-id="element-64">{card.sub}</p>
        </div>)}
    </div>;
}